module.exports = __webpack_public_path__ + "static/media/banner-momentos-bravecto-fim-desktop.faee71f3.webp";